/** @format */
import { DashboardActions } from "../actionsName";
type dashboardParams = {
  header1: any;
  header2: any[];
  header3: any[];
  akb: any[];
  snp: any[];
  listSumberDana: any[];
  indikatifHeader1: any;
  indikatifHeader2: any[];
  cacheTime: any;
};

const initialDashboardState: dashboardParams = {
  header1: {},
  header2: [],
  header3: [],
  akb: [],
  snp: [],
  listSumberDana: [],
  indikatifHeader1: {},
  indikatifHeader2: [],
  cacheTime: {},
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dashboardReducers = (state = initialDashboardState, action): any => {
  switch (action.type) {
    case DashboardActions.SET_DASHBOARD:
      return {
        ...state,
        ...action.data,
      };

    case DashboardActions.CLEAR_DASHBOARD:
      return initialDashboardState;
    default:
      return state;
  }
};

export default dashboardReducers;
